import { Column } from 'hooks/useMuiTableBuilderV2';

export enum Columns {
  Checkbox = 'checkbox',
  Copy = 'copy',
  Impersonation = 'impersonation',
  AccountId = 'account_id',
  Name = 'name',
  Email = 'email',
  Role = 'role_name',
  LastActive = 'last_active',
  IsActive = 'is_active',
}

const checkboxColumn: Column = {
  id: Columns.Checkbox,
};

const copyColumn: Column = {
  id: Columns.Copy,
};

const impersonationColumn: Column = {
  id: Columns.Impersonation,
};

const accountIdColumn: Column = {
  id: Columns.AccountId,
  label: 'Account ID',
};

const nameColumn: Column = {
  id: Columns.Name,
  label: 'Name',
};

const emailColumn: Column = {
  id: Columns.Email,
  label: 'Email',
};

const isActiveColumn: Column = {
  id: Columns.IsActive,
  label: 'Is Activated',
};

const roleColumn: Column = {
  id: Columns.Role,
  label: 'Role',
};

const lastActiveColumn: Column = {
  id: Columns.LastActive,
  label: 'Last Active',
};

export const columns = [
  checkboxColumn,
  copyColumn,
  impersonationColumn,
  accountIdColumn,
  nameColumn,
  emailColumn,
  roleColumn,
  lastActiveColumn,
  isActiveColumn,
];
